export default __webpack_public_path__ + "static/media/powered_by_bessy.da9d7d2b.svg";